module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting"
  }, [_c('el-col', {
    staticClass: "setting-categories",
    attrs: {
      "span": 5
    }
  }, [(this.$store.state.isSystemAdminMode) ? _c('div', [_c('div', {
    staticClass: "setting-category",
    class: _vm.settingCategory === 0 ? 'onSetttng' : '',
    on: {
      "click": function($event) {
        return _vm.setCategory(0)
      }
    }
  }, [_vm._v("\n                    熱門主題\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "setting-category",
    class: _vm.settingCategory === 1 ? 'onSetttng' : '',
    on: {
      "click": function($event) {
        return _vm.setCategory(1)
      }
    }
  }, [_vm._v("\n                    統計報表\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "setting-category",
    class: _vm.settingCategory === 2 ? 'onSetttng' : '',
    on: {
      "click": function($event) {
        return _vm.setCategory(2)
      }
    }
  }, [_vm._v("\n                    學院主題分類\n                ")])]) : (this.$store.state.isBackendMode) ? _c('div', [_c('div', {
    staticClass: "setting-category",
    class: _vm.settingCategory === 3 ? 'onSetttng' : '',
    on: {
      "click": function($event) {
        return _vm.setCategory(3)
      }
    }
  }, [_vm._v("\n                    部門主題分類排序\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "setting-category",
    class: _vm.settingCategory === 4 ? 'onSetttng' : '',
    on: {
      "click": function($event) {
        return _vm.setCategory(4)
      }
    }
  }, [_vm._v("\n                    個人主題分類排序\n                ")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "setting-title"
  }, [_vm._v("\n                " + _vm._s(_vm.categoryTitle) + " \n                "), _c('div', {
    staticClass: "sub-setting-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.subCategoryTitle) + " \n                    "), _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [(_vm.settingCategory === 3 || _vm.settingCategory === 4) ? _c('el-button', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.restoreCategoryOrder
    }
  }, [_vm._v("\n                            恢復預設值\n                        ")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "setting-table",
    attrs: {
      "trigger": "hover"
    }
  }, [(_vm.settingCategory === 0) ? _c('el-row', {
    staticClass: "setting-item"
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', [_vm._v("\n                            熱門主題統計區間\n                        ")])]), _vm._v(" "), (_vm.topicRange.isEdit) ? _c('div', {
    staticClass: "setting-content"
  }, [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_vm._v("\n                            最近\n                            "), _c('el-input', {
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.topicRange.value),
      callback: function($$v) {
        _vm.$set(_vm.topicRange, "value", _vm._n($$v))
      },
      expression: "topicRange.value"
    }
  }), _vm._v("\n                            天\n                        ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.saveEdit(_vm.topicRange)
      }
    }
  }, [_vm._v("儲存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.cancelEdit(_vm.topicRange)
      }
    }
  }, [_vm._v("取消")])], 1)], 1) : _c('div', {
    staticClass: "setting-content"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_vm._v("\n                                最近 " + _vm._s(_vm.topicRange.value) + " 天\n                            ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('img', {
    staticClass: "edit-icon",
    attrs: {
      "src": require("../../assets/icon/ic_edit_blue.png"),
      "alt": "E"
    },
    on: {
      "click": function($event) {
        return _vm.setEdit(_vm.topicRange)
      }
    }
  })])], 1)], 1) : (_vm.settingCategory === 1) ? _c('el-row', _vm._l((_vm.reportSetting), function(item, index) {
    return _c('el-row', {
      key: index,
      staticClass: "setting-item",
      class: _vm.getExtraRowStyle(index)
    }, [_c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('div', [_vm._v("\n                                " + _vm._s(item.title) + "\n                            ")])]), _vm._v(" "), (item.isEdit) ? _c('div', {
      staticClass: "setting-content"
    }, [_c('el-col', {
      attrs: {
        "span": 9
      }
    }, [_vm._v("\n                                " + _vm._s(item.descPre) + "\n                                "), _c('el-input', {
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "size": "small"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", _vm._n($$v))
        },
        expression: "item.value"
      }
    }), _vm._v("\n                                " + _vm._s(item.descPost) + "\n                            ")], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.saveEdit(item)
        }
      }
    }, [_vm._v("儲存")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.cancelEdit(item)
        }
      }
    }, [_vm._v("取消")])], 1)], 1) : _c('div', {
      staticClass: "setting-content"
    }, [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('div', [_vm._v("\n                                    " + _vm._s(item.descPre) + " " + _vm._s(item.value) + " " + _vm._s(item.descPost) + "\n                                ")])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('img', {
      staticClass: "edit-icon",
      attrs: {
        "src": require("../../assets/icon/ic_edit_blue.png"),
        "alt": "E"
      },
      on: {
        "click": function($event) {
          return _vm.setEdit(item)
        }
      }
    })])], 1)], 1)
  }), 1) : (_vm.settingCategory === 2) ? _c('el-row', [_c('College', {
    attrs: {
      "collegeList": _vm.categoryGroupList
    },
    on: {
      "getCategoriesGroup": _vm.getCategoriesGroup
    }
  })], 1) : (_vm.settingCategory === 3) ? _c('el-row', [_c('CategoryOrder', {
    key: _vm.refreshKey,
    attrs: {
      "categoryGroupList": _vm.categoryGroupList,
      "type": "dep"
    }
  })], 1) : (_vm.settingCategory === 4) ? _c('el-row', [_c('CategoryOrder', {
    key: _vm.refreshKey,
    attrs: {
      "categoryGroupList": _vm.categoryGroupList,
      "type": "user"
    }
  })], 1) : _c('el-row')], 1)]), _vm._v(" "), _c('hint', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hint.display && this.$store.state.hintStatus.setting),
      expression: "hint.display && this.$store.state.hintStatus.setting"
    }],
    attrs: {
      "message": _vm.hint.message
    },
    on: {
      "close": _vm.closeHint
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-414f4b02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/Setting.vue
// module id = 919
// module chunks = 170